import React from "react";
import "./AboutUs.css";
import Image1 from '../images/dir4.JPG'
import { FaCheckCircle } from "react-icons/fa";

const AboutUs = () => {
  return (
    <section className="about-us-section text-white">
      <div className="container">
        <div className="row align-items-center">
        <h1 className="sec-head">
            About Seal Active
            </h1>
          {/* Left Side: Company Image */}
          <div className="col-md-6 about-image">
            <img
              src={Image1}
              alt="SealActive"
              className="img-fluid1 rounded shadow"
            />
          </div>

          <div className="col-md-6 about-content">
            <p className="about-description">
              At SealActive Pvt Ltd, we specialize in innovative adhesive solutions for businesses across India. Founded by experienced engineers, our mission is to deliver superior-quality products that exceed expectations.
            </p>
            <p className="about-highlight">
              We offer a diverse portfolio of <strong>HOT MELT AND COLD ADHESIVES</strong> designed for industries like packaging and textiles. Our products provide:
            </p>
            <ul className="about-features">
              <li>
                <FaCheckCircle className="tick-icon" /> Superior performance
              </li>
              <li>
                <FaCheckCircle className="tick-icon" /> Cost efficiency
              </li>
              <li>
                <FaCheckCircle className="tick-icon" /> Environmental sustainability
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
